import { render, staticRenderFns } from "./EmployeeSkills.vue?vue&type=template&id=66d8273e&scoped=true&"
import script from "./EmployeeSkills.vue?vue&type=script&lang=ts&"
export * from "./EmployeeSkills.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeSkills.vue?vue&type=style&index=0&id=66d8273e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d8273e",
  null
  
)

component.options.__file = "EmployeeSkills.vue"
export default component.exports